import { Component, OnInit, Input, Output, EventEmitter, input, signal } from '@angular/core';
import { Asset } from '../../classes/asset';
import { APIService } from '../../shared/api.service';
import { AssetService } from 'app/shared/asset.service';
import { RedisService } from 'app/shared/redis.service';

@Component({
  selector: 'app-asset-viewer',
  templateUrl: './asset-viewer.component.html',
  styleUrls: ['./asset-viewer.component.css'],
  providers: [],
  standalone: false
})
export class AssetViewerComponent implements OnInit {

  assetId = input.required<number>();
  wantsDetails = input<boolean>(true);
  wantsChart = input<boolean>(true);
  wantsExtendedDetails = input<boolean>(false);

  asset = signal<Asset>(null);
  canEdit: boolean;
  isAdmin: boolean;
  fullscreen = false;
  openDialog = signal<boolean>(false);

  @Output()
  hasLoaded: EventEmitter<void> = new EventEmitter();

  constructor(private assetService: AssetService, private apiService: APIService, private redisService: RedisService) { }

  ngOnInit(): void {
    this.canEdit = this.apiService.hasOrgRole('amend_asset') || this.apiService.isAdmin();
    this.isAdmin = this.apiService.isAdmin();
    if (this.assetId) {
      this.assetService.getAsset(this.assetId())
        .then(asset => {
          this.redisService.getAsset(this.assetId()).then(redisAsset => {
            asset.redis = redisAsset;
            this.asset.set(asset);
            this.hasLoaded.emit();
          });
        });
    }
  }

  toolbarClick(event: any) {
    this.openDialog.set(true);
    /**    const dialogRef = this.dialogService.open(DialogAssetEditComponent, {
      header: `Update ${this.asset().title}`,
      data: { asset: this.asset }
    });
    dialogRef.onClose.subscribe((license: License) => {
      if (license) {
        this.apiService.toastSuccess('Asset updated');
      }
    });
    */
  }

}
